// Add your custom JS here.

//add title underline

function addUnderline(el) {
	
	let ul_els = document.querySelectorAll(el);
	for(let e in ul_els) {
		if(ul_els.hasOwnProperty(e)) {

			let title = ul_els[e];
			let newNode = document.createElement('div');
			newNode.classList.add('title-border');
			title.after(newNode);
			
		}
	}

}

//make sure all title have an underline
document.addEventListener("DOMContentLoaded", () => {
		
	$('#get-vcard, .vcard-button').click(function() {

		let data = {
				'attorney': $(this).attr('data-attorney'),
				'action': 'get_vcard'
				};

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			method: 'post',
			data: data,
			dataType: 'json',
			success: function(r) {

				let response = JSON.parse(r);
				location.href = response.file;
			}
		});

	});
			
	
	
  //setup borders under titles
  addUnderline('.wp-block-columns .wp-block-heading, .wp-block-group h2, article h2');
});


//slide in the columns
$(document).on("scroll", function() {
  var pageTop = $(document).scrollTop();
  var pageBottom = pageTop + $(window).height();
  var tags = $(".wp-block-columns");

  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];
	// console.log($(tag).position().top);
	// console.log(pageBottom);
    if ($(tag).position().top < pageBottom) {
      $(tag).addClass("visible");
    } else {
      $(tag).removeClass("visible");
    }
  }
});


//show the full news aricle
$('body').on( 'click', '.news-item', function(e) {
	
	
	if($('#news-overlay').length == 1) {
		
		//copy the html
		// console.log(e.target);
		let data = $(e.target)
						.closest('.news-item')
						.find('.news-overlay-container')
						.html();
					
						console.log(data);
		//paste the html
		let wrap = 	$('#news-overlay').find('.flex-box').html(data);
	
	
		$('#news-overlay')
				.toggle();
		return false;
		
	}
	
	
});


//close the news article
$('#news-overlay').on('click', '#close-news-item', function() {
	$('#news-overlay').toggle().find('.flex-box').html();

	return false;	
});

$('.lectures-list .lecture').slice(10).hide();
//load more
$('.load-more').on('click', function() {
  
	$('.card').show();
	$(this).hide();
	  
});



